import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import reject from 'lodash/reject';
import uniqBy from 'lodash/uniqBy';
import ACTION_TYPES from '../../constants/actionTypes';

const reducers = {

  account(state = {}, action) {
    let newState = cloneDeep(state);
    switch (action.type) {
      case ACTION_TYPES.SIGN_IN_SUCCESS:
      case ACTION_TYPES.SIGN_UP_SUCCESS:
      case ACTION_TYPES.GET_ACCOUNT_INFO_SUCCESS:
      case ACTION_TYPES.UPDATE_ACCOUNT_INFO_SUCCESS:
        return {
          firstName: action.payload.account.first_name,
          middleName: action.payload.account.middle_name,
          lastName: action.payload.account.last_name,
          phoneNumber: action.payload.account.phone_number,
          email: action.payload.account.email,
          publicId: action.payload.account.public_id,
          country: action.payload.account.country,
          region: action.payload.account.region,
          beneficiaryFirstName: action.payload.account.beneficiary.first_name,
          beneficiaryLastName: action.payload.account.beneficiary.last_name,
          beneficiaryEmail: action.payload.account.beneficiary.email,
          paymentMethods: filter(action.payload.account.payment_methods, { type: 'CREDIT_CARD_STRIPE' }),
        };
      case ACTION_TYPES.ADD_PAYMENT_METHOD_SUCCESS:
        newState.paymentMethods.unshift(action.paymentMethod);
        newState.paymentMethods = uniqBy(newState.paymentMethods, 'public_id');
        return newState;
      case ACTION_TYPES.DELETE_PAYMENT_METHOD_REQUEST:
        newState.paymentMethods = reject(newState.paymentMethods, { public_id: action.paymentMethodId });
        return newState;
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  isFetchingAccountInfo(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_ACCOUNT_INFO:
        return true;
      case ACTION_TYPES.GET_ACCOUNT_INFO_SUCCESS:
      case ACTION_TYPES.GET_ACCOUNT_INFO_FAILURE:
        return false;
      default:
        return state;
    }
  },

  isAddPaymentMethodInProgress(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.ADD_PAYMENT_METHOD_REQUEST:
        return true;
      case ACTION_TYPES.ADD_PAYMENT_METHOD_SUCCESS:
      case ACTION_TYPES.ADD_PAYMENT_METHOD_FAILURE:
        return false;
      default:
        return state;
    }
  },

};

export default reducers;
